import React, { forwardRef, useMemo } from "react";
import "./PortfolioItem.css";

function truncate(text, max = 230) {
  const value = String(text || "");
  if (value.length <= max) return value;
  const cut = value.slice(0, max);
  const lastSpace = cut.lastIndexOf(" ");
  return `${lastSpace > 80 ? cut.slice(0, lastSpace) : cut}...`;
}

const PortfolioItem = forwardRef(function PortfolioItem({ item, onOpen, highlighted }, ref) {
  const description = useMemo(() => truncate(item.description, 240), [item.description]);

  return (
    <button
      ref={ref}
      type="button"
      className={["pCard", highlighted ? "is-highlighted" : ""].join(" ")}
      onClick={onOpen}
      aria-label={`Open ${item.company_name}: ${item.title}`}
    >
      <span className="pCard__logo">
        <img
          src={`${process.env.PUBLIC_URL}/${item.imageUrl}`}
          alt=""
          onError={(event) => {
            event.currentTarget.style.opacity = "0.2";
          }}
        />
      </span>

      <span className="pCard__body">
        <span className="pCard__company">{item.company_name}</span>
        <span className="pCard__role">{item.title}</span>
        <span className="pCard__desc">{description}</span>

        <span className="pCard__tags" aria-hidden="true">
          {(item.tech_stack || []).slice(0, 6).map((technology) => (
            <span key={technology} className="pTag">{technology}</span>
          ))}
        </span>
      </span>

      <span className="pCard__foot" aria-hidden="true">
        <span className="pCard__date">{item.date}</span>
        <span className="pCard__open">Open</span>
      </span>
    </button>
  );
});

export default PortfolioItem;
